import { render, staticRenderFns } from "./NoDataStaff.vue?vue&type=template&id=36705ffc&scoped=true&"
import script from "./NoDataStaff.vue?vue&type=script&lang=js&"
export * from "./NoDataStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36705ffc",
  null
  
)

export default component.exports